import { Reducer, combineReducers, configureStore, PayloadAction, createSlice, AnyAction } from "@reduxjs/toolkit";
import persistStore from "redux-persist/es/persistStore";
import { PersistGate } from "redux-persist/integration/react";
import { TypedUseSelectorHook, useDispatch, useSelector, Provider } from "react-redux";
import ThemeReducer, { ThemeState } from "../layout/theme/ThemeReducer";
import { PersistConfig, persistReducer } from "redux-persist";
import { PersistPartial } from "redux-persist/es/persistReducer";
import AsyncStorage from "@react-native-async-storage/async-storage";

interface SystemReducer {
  theme: Reducer<ThemeState & PersistPartial, AnyAction>;
}

interface StoreReducer extends SystemReducer {
  [key: string]: Reducer<any>;
}

const systemReducers: StoreReducer = {
  theme: ThemeReducer,
};
const store = configureStore({
  reducer: systemReducers,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({ serializableCheck: false, immutableCheck: false }),
});

const loadReducers = (reducers: { [key: string]: Reducer<any> }) => {
  store.replaceReducer(combineReducers({ ...systemReducers, ...reducers }));
  persistor.persist();
};

// Infer the `AppState` and `AppDispatch` types from the store itself
type AppState = ReturnType<typeof store.getState>;

// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
type AppDispatch = typeof store.dispatch;
const useAppDispatch: () => AppDispatch = useDispatch;

// selector
type AppSelector<S> = (state: AppState) => S;
const useAppSelector: TypedUseSelectorHook<AppState> = useSelector;

// persistor
const persistor = persistStore(store);

export {
  store,
  persistor,
  AppState,
  AppDispatch,
  AppSelector,
  useAppDispatch,
  useAppSelector,
  Provider as StoreProvider,
  PersistGate as StorePersistGate,
  loadReducers,
  Reducer as StoreReducer,
  persistReducer as createPersistReducer,
  PersistConfig,
  PayloadAction,
  createSlice as initReducer,
  useSelector,
  AsyncStorage as Storage,
  TypedUseSelectorHook,
};
